import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

class UnitFormDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    unit: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    unit: {
      name: '',
      location: { address: '' },
    },
  }

  static styles = {}

  state = { ...this.props.unit }

  onUnitNameChange = (e) => {
    this.setState({ name: e.currentTarget.value })
  }

  onUnitAddressChange = (e) => {
    this.setState({ location: { address: e.currentTarget.value } })
  }

  onSubmit = () => {
    const unit = this.state
    if (unit.community_id === '') {
      unit.community_id = 0
    }
    this.props.onSubmit(unit)
    this.props.onClose()
  }

  render() {
    const { title, onClose } = this.props

    return (
      <Dialog open onClose={onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>

        <DialogContent>
          <div>
            <TextField label="Unit Name" value={this.state.name} onChange={this.onUnitNameChange} />
          </div>
          <div>
            <TextField label="Address" value={this.state.location.address} onChange={this.onUnitAddressChange} />
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button onClick={this.onSubmit} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(UnitFormDialog.styles)(UnitFormDialog)
